export default {
  // Labels sueltos especificos del modulo exhibitions
  subtitle: 'Exhibition continuity',
  filteredResults: 'Results of your filtered search',
  elapsedDays: 'Days elapsed:',
  daysUnit: 'days',
  folioPrefix: 'No.',
  noResults: 'No results',
  cancel: 'Cancel',

  // Labels de estado (badges/filtro de status)
  status: {
    all: 'All',
    active: 'Active',
    finished: 'Finished',
    activeBadge: 'Active',
    finishedBadge: 'Finished',
    label: 'Status'
  },

  // Labels de la vista de detalle de una exhibicion
  detail: {
    title: 'Exhibition continuity',
    promoter: 'Promoter',
    supervisor: 'Supervisor',
    type: 'Exhibition type',
    location: 'Location',
    place: 'Exhibition place',
    date: 'Date',
    elapsedDays: 'Days elapsed',
    state: 'Status',
    addEvidence: 'Add evidence',
    evidence: 'Evidence',
    viewLog: 'View log',
    finalize: 'Finalize',
    log: 'Log'
  },

  // Labels del formulario de creacion/edicion de exhibicion
  form: {
    title: 'New Exhibition',
    content: 'Exhibition content',
    searchCatalog: 'Search the catalog...',
    type: 'Exhibition type',
    selectType: 'Select a type',
    location: 'Location',
    place: 'Exhibition place',
    placeHint: 'E.g. Grocery aisle',
    promoter: 'Assign a promoter',
    selectUser: 'Select user',
    addEvidence: 'Add evidence',
    create: 'Create'
  },

  // Mensajes de validacion con redaccion especifica de exhibitions
  validation: {
    title: 'This exhibition cannot be created',
    close: 'Close',
    prefix: 'To complete this exhibition, {reason}',
    content: 'please select the exhibition content.',
    type: 'please select the exhibition type.',
    location: 'please select a location.',
    promoter: 'please assign a promoter.',
    evidence: 'please add photographic evidence.'
  },

  // Textos de dialogos de confirmacion
  confirm: {
    createTitle: 'Do you want to create this exhibition?',
    createMessage: 'The exhibition will be created and cannot be changed.',
    finalizeTitle: 'Finalize exhibition?',
    finalizeMessage: 'The closing date will be recorded and you will not be able to add more evidence.'
  },

  // Toasts de exito/error de acciones de exhibitions
  messages: {
    created: 'Exhibition created successfully',
    createError: 'The exhibition could not be created',
    loadError: 'The list could not be loaded and may be outdated',
    evidenceAdded: 'Evidence added',
    evidenceError: 'The evidence could not be added',
    evidenceRemoved: 'Evidence removed',
    evidenceRemoveError: 'The evidence could not be removed',
    finalized: 'Exhibition finalized successfully',
    finalizeError: 'The exhibition could not be finalized'
  },

  // Labels del panel de filtros del listado de exhibitions
  filters: {
    title: 'Filters',
    location: 'Location',
    responsible: 'Responsible',
    product: 'Product',
    searchProduct: 'Search',
    clearAll: 'Clear all filters',
    sort: 'Sort',
    showResults: 'Show Results'
  },

  // Labels del panel de ordenamiento del listado de exhibitions -> exhibitions.js.
  sort: {
    title: 'Select the sorting',
    sortBy: 'Sort by:',
    fieldTitle: 'Title',
    responsible: 'Responsible',
    location: 'Location',
    status: 'Status',
    createdAt: 'Creation date',
    asc: 'Ascending',
    desc: 'Descending',
    addCriterion: 'Add criterion',
    clearCriteria: 'Clear criteria',
    apply: 'Sort'
  },

  // Labels del selector de ubicacion
  location: {
    search: 'Search a location',
    loading: 'Loading locations...',
    selectedPrefix: 'You selected',
    selectedSuffix: 'as Location.',
    // Vacio a proposito: el ingles no necesita un verbo introductorio antes de
    // "click here" (a diferencia del espanol "Haz click aqui"). Ver TKT-1575
    // p5-025 (anti-patron: oracion armada concatenando 5 claves + markup).
    changeIntro: '',
    changeLink: 'click here',
    changeOutro: 'to change the location.'
  },

  // Evidencia de exhibitions
  evidence: {
    maxReached: 'Maximum {max} photos per upload.'
  },

  // Bitacora/log de una exhibicion
  log: {
    created: 'created this exhibition on:',
    picture: 'added an evidence:',
    deleted: 'removed an evidence:',
    deletedMessage: 'An evidence was removed.',
    finished: 'finalized this exhibition:',
    datePrefix: 'Date:',
    finishedMessage: 'The exhibition has been finalized.',
    viewMore: 'View more',
    imageName: 'Image',
    empty: 'No records in the log.',
    user: 'User'
  },

  // Labels del panel admin de catalogo/exhibitions
  admin: {
    tabCatalog: 'Catalog',
    tabExhibitions: 'Exhibitions',
    save: 'Save',
    empty: 'No records.',
    saved: 'Saved successfully',
    saveError: 'Could not save',
    deleted: 'Record deleted',
    deleteError: 'Could not delete',
    deleteConfirmTitle: 'Delete record',
    deleteConfirmMessage: 'Are you sure you want to delete this record?',
    importTitle: 'Import catalog',
    importButton: 'Import catalog',
    importNote: '*The file has more than 1 column.',
    importSuccess: 'Catalog imported successfully',
    importError: 'Could not import the catalog',
    importSkipped: 'Rows skipped without description: {count}',
    productAddTitle: 'Add a New Product',
    productAddButton: 'Add Product',
    productPlaceholder: 'Type your product here..',
    productListTitle: 'Catalog',
    productSearch: 'Search a product',
    typeAddTitle: 'Add an Exhibition Type',
    typeAddButton: 'Add Exhibition Type',
    typePlaceholder: 'Type your exhibition type here..',
    typeListTitle: 'Exhibition Type',
    placeAddTitle: 'Add an Exhibition Place',
    placeAddButton: 'Add Exhibition Place',
    placePlaceholder: 'Type your exhibition place here..',
    placeListTitle: 'Exhibition Place'
  },

  // Labels de la pantalla de configuracion
  settings: {
    title: 'Settings',
    tabCatalog: 'Catalog',
    tabExhibition: 'Exhibition'
  }
}
